// src/hooks/useActionCount.js
// 「要対応」の件数（サイドバーのバッジ用）【2026-11-02】
//   GET /api/dashboard/action-items?summary=1 を、開いた時・2分ごと（画面が見えているとき）・
//   window の 'action-items-changed'（要対応の画面などで片付けたとき）で取り直す。
//   先生・教務だけ。ほかのロールは常に 0（呼ばない）。
import { useCallback, useEffect, useState } from 'react';

const ROLES = ['teacher', 'academic_staff'];

/** 件数と項目ごとの件数 { total, sections: [{ key, title, count, note }] } */
export function useActionSummary(user) {
  const [state, setState] = useState({ total: 0, sections: [], loaded: false });
  const enabled = !!(user && user.id && ROLES.includes(user.role));

  const refresh = useCallback(async () => {
    if (!enabled) { setState({ total: 0, sections: [], loaded: true }); return; }
    try {
      const r = await fetch('/api/dashboard/action-items?summary=1', {
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
      });
      if (!r.ok) return;
      const j = await r.json();
      if (j && j.success) setState({ total: Number(j.total) || 0, sections: j.sections || [], loaded: true });
    } catch (e) { /* 取れなくても画面は動く */ }
  }, [enabled]);

  useEffect(() => {
    refresh();
    if (!enabled) return undefined;
    const t = setInterval(() => { if (document.visibilityState === 'visible') refresh(); }, 120000);
    const onChange = () => refresh();
    const onVisible = () => { if (document.visibilityState === 'visible') refresh(); };
    window.addEventListener('action-items-changed', onChange);
    document.addEventListener('visibilitychange', onVisible);
    return () => {
      clearInterval(t);
      window.removeEventListener('action-items-changed', onChange);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, [refresh, enabled]);

  return state;
}

/** 件数だけ（サイドバーのバッジ） */
export default function useActionCount(user) {
  return useActionSummary(user).total;
}

/** ダッシュボードの「要対応」カード（DashboardParts の AlertCard）に入れる行 */
export function actionRows(sections) {
  return (sections || []).filter(s => s.count > 0).map(s => ({
    key: 'action-' + s.key,
    level: s.key === 'alerts' ? ((s.detail && s.detail.serious) ? 'crit' : 'warn')
         : s.key === 'merge' ? 'note' : 'warn',
    title: `${s.title} ${s.count}${s.countCapped ? '+' : ''}件`,
    meta: s.note || undefined,
    to: '/todo',
    action: '開く',
  }));
}
